import React, { Component } from 'react';
import './PrioritiesFutureComponent.css';
import _ from 'lodash';
import { Link } from 'react-router-dom';

class PrioritiesFutureComponent  extends Component {
    constructor(props) {
        super(props);
        this.defaultParams;
        this.state = {
            data:{
                first: '',
                second: '',
                third: '',
            },
            inputStates: {
                first: false,
                second: true,
                third: true,
            }
        };
    }

    componentWillMount(){
        // if(this.props.getInfluencerMapGroupsData.Items[0].groups.length < 2){
        //     let state = _.extend({}, this.state);
        //     //state.inputStates.second = true;
        //     state.inputStates.third = true;
        // }
        // if(this.props.getInfluencerMapGroupsData.Items[0].groups.length < 3){
        //     let state = _.extend({}, this.state);
        //     state.inputStates.second = true;
        //     state.inputStates.third = true;
        // }
        if(this.props.getInfluencerMapGroupsData.Items[0].priorities){
            let state = _.extend({}, this.state);
            state.inputStates.first = true;
            state.inputStates.second = true;
            state.inputStates.third = true;

            this.props.getInfluencerMapGroupsData.Items[0].priorities.future[0] && ( state.data.first = this.props.getInfluencerMapGroupsData.Items[0].priorities.future[0])
            this.props.getInfluencerMapGroupsData.Items[0].priorities.future[1] && (state.data.second = this.props.getInfluencerMapGroupsData.Items[0].priorities.future[1])
            this.props.getInfluencerMapGroupsData.Items[0].priorities.future[2] && (state.data.third = this.props.getInfluencerMapGroupsData.Items[0].priorities.future[2])
            
        }
    }

    validateForm = () => {
        let validationStates = _.extend({}, this.state.inputStates);
        let key = Object.values(validationStates).indexOf(false) !== -1;
        let state = !key;
        
        this.setState({ formValid: state }, () => {

            this.state.formValid && this.props.validateFuture(this.state.data)
        });
    }
    
    onDataChange = (key, event, valid) => {
        const value = event.target.value;
        let state = _.extend({}, this.state);
            state.inputStates[key] = valid;
            state.data[key] = value;
            this.setState(state, () => this.validateForm());
            //this.props.craetePrioritiesArr('future', value);
    };

    render() {
        
        return (
            <div className='small-result-box'>
                <h4>After this analysis</h4>
                <form>
                    <div className='form-group'>
                        <select 
                            className='form-control'
                            //onChange={(e) => { this.onDataChange(e)}} 
                            onChange={(e, valid) => this.onDataChange('first', e, valid)}
                            value={this.state.data.first} 
                        >
                            {/* <option value='' >Select One</option> */}
                                {/* <option value='small'>Small</option>
                                <option value='middle'>Middle</option>
                                <option value='large'>Large</option> */}
                                <option value=''>Select</option>
                                {_.map(this.props.getInfluencerMapGroupsData.Items[0].groups, (value, index) => {
                                    return(
                                        <option value={value.groupId}>{value.groupName}</option>
                                    )
                                })}
                        </select>
                        {this.props.getInfluencerMapGroupsData.Items[0].groups.length > 1 &&
                            <select 
                                className='form-control'
                                //onChange={(e) => { this.onDataChange(e)}} 
                                onChange={(e, valid) => this.onDataChange('second', e, valid)}
                                value={this.state.data.second} 
                            >
                                <option value=''>Select</option>
                                {_.map(this.props.getInfluencerMapGroupsData.Items[0].groups, (value, index) => {
                                    return(
                                        <option value={value.groupId}>{value.groupName}</option>
                                    )
                                })}
                            </select>
                        }
                        {this.props.getInfluencerMapGroupsData.Items[0].groups.length > 2 &&
                            <select 
                                className='form-control'
                                //onChange={(e) => { this.onDataChange(e)}} 
                                onChange={(e, valid) => this.onDataChange('third', e, valid)}
                                value={this.state.data.third} 
                            >
                                <option value=''>Select</option>
                                {_.map(this.props.getInfluencerMapGroupsData.Items[0].groups, (value, index) => {
                                    return(
                                        <option value={value.groupId}>{value.groupName}</option>
                                    )
                                })}
                            </select>
                        }
                    </div>
                </form>
            </div>
        )
    }
}

export default (PrioritiesFutureComponent);



// WEBPACK FOOTER //
// ./src/components/InfluencerMap/InfluencerMapSelects/PrioritiesFutureComponent/PrioritiesFutureComponent.jsx